module.exports = __webpack_public_path__ + "img/DAVID_CANNON_34-rs.3ded4ff1.jpg";